<template>
    <div class="card-accordion card-accordion--lozenge" :class="{ 'toggled': active }">
        <div class="card-accordion__left">
            <p class="loz card-accordion__lozenge h6 my-none" :class="lozClass">{{ post.points }} {{ post.pointsOption[0] }}</p>
            <p class="h6 card-accordion__sub-heading">
                <span v-for="(loc, index) in locations" :key="loc">
                    {{ loc }}<template v-if="index != locations.length - 1">, </template>
                </span>
            </p>
        </div>

        <div class="card-accordion__right">
            <p class="h4 card-accordion__heading">{{ post.title }}</p>
            <div class="card-accordion__toggled-content">
                <p class="card-accordion__summary">{{ post.summary }}</p>

                <div class="card-accordion__content">
                    <div class="card-accordion__content-block">
                        <p class="h6 card-accordion__content-block-heading">Duration</p>
                        <p class="card-accordion__content-block-text">{{ post.duration }}</p>
                    </div>
                    <div class="card-accordion__content-block">
                        <p class="h6 card-accordion__content-block-heading">Training Provider</p>
                        <p class="card-accordion__content-block-text">{{ post.provider }}</p>
                    </div>
                    <div class="card-accordion__content-block">
                        <p class="h6 card-accordion__content-block-heading">Training link</p>
                        <a :href="post.website" target="_blank" class="text--orange card-accordion__content-block-text">Access training</a>
                    </div>
                    <div class="card-accordion__content-block">
                        <p class="h6 card-accordion__content-type">CPD Points</p>
                        <p class="card-accordion__content-data">{{ post.points }}</p>
                    </div>
                </div>
            </div>

            <div class="expand card-accordion__toggle" @click="active = !active">
                <svg class="icon expand__plus-outline">
                    <use xlink:href="#plus-outline"></use>
                </svg>
                <svg class="icon expand__plus-solid">
                    <use xlink:href="#plus-solid"></use>
                </svg>
                <svg class="icon expand__minus-outline">
                    <use xlink:href="#minus-outline"></use>
                </svg>
                <svg class="icon expand__minus-solid">
                    <use xlink:href="#minus-solid"></use>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        post: {
            type: Object,
            required: true
        },

        states: {
            types: Array,
            required: true
        }
    },

    data() {
        return {
            active: false,
        };
    },

    computed: {
        locations() {
            const ausWide = this.states.every(state => this.post.location.includes(state));
            return ausWide ? ['Australia wide'] : this.post.location;
        },

        lozClass() {
            let klass = 'loz--ghost';
            if (this.post.pointsOption[0] === 'Core') klass = 'loz--orange';
            if (this.post.pointsOption[0] === 'Elective') klass = 'loz--dark';

            return klass;
        },
    },
};
</script>

<style lang="scss" scoped>
    .post-component {
        display: flex;
        padding: 3em;
        border: 1px solid #DDDDDD;
        border-left: 8px solid #EF6E0B;
        box-shadow: 0 1px 3px #DDDDDD;
        margin-bottom: 3em;
    }

    .post-component-image {
        flex-shrink: 0;
        width: 100px;
    }

    .post-component-description {
        flex-grow: 1;
        margin: 0 3em;
    }

    .post-component-info {
        flex-basis: 210px;
        font-size: 14px;
    }

    .card-accordion__lozenge {
        width: 130px;
        margin-right: 3rem;
    }

    .btn {
        margin-bottom: 1em;
    }

    ul {
        li {
            margin-bottom: 0.5em;
        }

        strong {
            display: block;
        }
    }
</style>
